/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module media-embed
 */

import MediaEmbed from './mediaembed';
import MediaEmbedEditing from './mediaembedediting';
import MediaEmbedUI from './mediaembedui';
import AutoMediaEmbed from './automediaembed';
import MediaEmbedToolbar from './mediaembedtoolbar';

export default {
	MediaEmbed,
	MediaEmbedEditing,
	MediaEmbedUI,
	MediaEmbedToolbar,
	AutoMediaEmbed
};
